import ICONS from "./icons";

const skillsListData = [
  {
    title: "Languages",
    key: "languages",
    children: [
      {
        title: "Python",
        key: "python",
        icon: ICONS.PYTHON,
      },
      {
        title: "JavaScript",
        key: "javascript",
        icon: ICONS.JAVASCRIPT,
      },
      {
        title: "HTML",
        key: "html",
        icon: ICONS.HTML,
      },
      {
        title: "CSS",
        key: "css",
        icon: ICONS.CSS,
      },
      {
        title: "SQL",
        key: "sql",
        icon: ICONS.SQL,
      },
      {
        title: "Latex",
        key: "latex",
        icon: ICONS.LATEX,
      },
    ],
  },
  {
    title: "Frameworks/Libraries",
    key: "frameworks-libraries",
    children: [
      {
        title: "Django",
        key: "django",
        icon: ICONS.DJANGO,
      },
      {
        title: "ReactJS",
        key: "react-js",
        icon: ICONS.REACT,
      },
      {
        title: "Bootstrap",
        key: "bootstrap",
        icon: ICONS.BOOTSTRAP,
      },
      {
        title: "Material UI",
        key: "material-ui",
        icon: ICONS.MATERIAL_UI,
      },
      {
        title: "Chakra UI",
        key: "chakra-ui",
        icon: ICONS.CHAKRA,
      },
    ],
  },
  {
    title: "Tools and Software",
    key: "tools-software",
    children: [
      {
        title: "VS Code",
        key: "vs-code",
        icon: ICONS.VSCODE,
      },
      {
        title: "Git",
        key: "git",
        icon: ICONS.GIT,
      },
      {
        title: "Docker",
        key: "docker",
        icon: ICONS.DOCKER,
      },
    ],
  },
];

export default skillsListData;
